var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJuloLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 87,
    viewBox: "0 0 176 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.9632 60.2371C86.9632 66.4213 83.5633 71.4006 76.1633 71.4006C68.7634 71.4006 65.5154 66.7236 65.5154 60.2371V40.6245H62.2634V60.3862C62.2634 68.5331 66.8494 74.5662 76.1653 74.5662C85.6292 74.5662 90.3652 68.0797 90.3652 60.5373V40.7756H87.1132L86.9632 60.2371Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.961 40.4732H104.561L104.413 73.9636L127.925 74.1147V71.0921L107.819 70.9471L107.961 40.4732Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150.699 39.7216C148.415 39.6744 146.146 40.0964 144.029 40.9619C141.913 41.8274 139.993 43.1182 138.388 44.7556C136.783 46.393 135.526 48.3427 134.693 50.4857C133.86 52.6288 133.47 54.9203 133.545 57.2205C133.573 60.6506 134.608 63.9955 136.521 66.8329C138.434 69.6703 141.139 71.873 144.294 73.163C147.448 74.4529 150.911 74.7722 154.246 74.0805C157.581 73.3889 160.637 71.7173 163.029 69.2768C165.422 66.8363 167.043 63.7363 167.688 60.3683C168.333 57.0002 167.973 53.5151 166.654 50.3529C165.335 47.1908 163.115 44.4933 160.275 42.6012C157.436 40.709 154.103 39.707 150.699 39.7216ZM150.551 71.5597C148.695 71.5931 146.853 71.2416 145.138 70.527C143.423 69.8124 141.872 68.75 140.582 67.4059C139.292 66.0618 138.291 64.4646 137.639 62.7138C136.988 60.9629 136.701 59.0958 136.797 57.2285C136.752 55.3611 137.079 53.5036 137.758 51.7653C138.436 50.027 139.453 48.443 140.748 47.1064C142.043 45.7698 143.59 44.7077 145.299 43.9825C147.008 43.2574 148.843 42.8838 150.697 42.8838C152.551 42.8838 154.386 43.2574 156.094 43.9825C157.803 44.7077 159.35 45.7698 160.645 47.1064C161.941 48.443 162.957 50.027 163.636 51.7653C164.314 53.5036 164.641 55.3611 164.597 57.2285C164.681 59.1171 164.377 61.003 163.703 62.7674C163.03 64.5318 162.001 66.1367 160.681 67.481C159.362 68.8254 157.781 69.8801 156.038 70.5789C154.294 71.2777 152.426 71.6055 150.551 71.5416V71.5597Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.036 8.94556H8V10.0015H9.036V8.94556Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.028 10.3037H12V11.3596H13.036L13.028 10.3037Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1679 11.9622H16.132V13.018H17.1679V11.9622Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3098 13.4714H20.2738V14.5273H21.3098V13.4714Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4478 15.1298H24.4198V16.1857H25.4538L25.4478 15.1298Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4418 16.488H28.4058V17.5439H29.4418V16.488Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2857 17.9973H32.2517V19.0532H33.2857V17.9973Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9838 19.2042H35.9478V20.2601H36.9838V19.2042Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3858 20.4092H39.3499V21.4651H40.3858V20.4092Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3241 12.8669H12.2881V13.9228H13.3241V12.8669Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8718 14.0739H15.8378V15.1298H16.8718V14.0739Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5759 15.2809H19.5419V16.3368H20.5759V15.2809Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2678 16.6391H23.2318V17.695H24.2678V16.6391Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9618 17.9973H26.9279V19.0532H27.9618V17.9973Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6617 19.2042H30.6257V20.2601H31.6617V19.2042Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2078 20.4092H34.1738V21.4651H35.2078V20.4092Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4617 21.6162H37.4277V22.6761H38.4617V21.6162Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7157 22.521H40.6797V23.5769H41.7157V22.521Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3158 16.488H16.2819V17.5439H17.3158V16.488Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4218 17.5439H19.3859V18.5998H20.4218V17.5439Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6758 18.6017H22.6398V19.6576H23.6758V18.6017Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0759 19.6576H26.0399V20.7135H27.0759V19.6576Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3277 20.7115H29.2937V21.7674H30.3277V20.7115Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7298 21.9186H32.6938V22.9745H33.7298V21.9186Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8358 22.8232H35.7998V23.8791H36.8358V22.8232Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9456 23.8812H38.9097V24.9371H39.9456V23.8812Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8937 24.786H41.8577V25.8419H42.8937V24.786Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M20.718 19.9579H19.682V21.0138H20.718V19.9579Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5239 20.7115H22.4899V21.7674H23.5239V20.7115Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4839 21.6162H25.4479V22.6761H26.4839V21.6162Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5897 22.521H28.5537V23.5769H29.5897V22.521Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5477 23.4258H31.5117V24.4817H32.5477V23.4258Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5057 24.3326H34.4697V25.3885H35.5057V24.3326Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4617 25.2374H37.4277V26.2933H38.4617V25.2374Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4197 25.993H40.3857V27.0489H41.4197V25.993Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0815 26.7466H43.0455V27.8025H44.0815V26.7466Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M23.824 23.1256H22.788V24.1815H23.824V23.1256Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3379 23.7301H25.3019V24.786H26.3379V23.7301Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9978 24.4838H27.9618V25.5397H28.9978V24.4838Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8077 25.2374H30.7717V26.2933H31.8077V25.2374Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4718 25.993H33.4358V27.0489H34.4718V25.993Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2797 26.7466H36.2437V27.8025H37.2797V26.7466Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9456 27.5003H38.9097V28.5562H39.9456V27.5003Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6019 28.1027H41.5679V29.1586H42.6019V28.1027Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1157 28.8585H44.0817V29.9144H45.1157V28.8585Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4839 26.1441H25.4479V27.2H26.4839V26.1441Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8498 26.5955H27.8138V27.6514H28.8498V26.5955Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2176 27.2H30.1816V28.2559H31.2176V27.2Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7298 27.8026H32.6938V28.8585H33.7298V27.8026Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2438 28.4051H35.2078V29.465H36.2438V28.4051Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7577 29.0096H37.7217V30.0655H38.7577V29.0096Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2718 29.6141H40.2358V30.67H41.2718V29.6141Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6377 30.2166H42.6017V31.2725H43.6377V30.2166Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0037 30.8192H44.9677V31.875H46.0037V30.8192Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7038 28.8585H27.6678V29.9144H28.7038V28.8585Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9198 29.3078H29.8938V30.3637H30.9278L30.9198 29.3078Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1397 29.7652H32.1038V30.8211H33.1397V29.7652Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5057 30.2166H34.4697V31.2725H35.5057V30.2166Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8698 30.8192H36.8418V31.875H37.8758L37.8698 30.8192Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0878 31.2725H39.0518V32.3284H40.0878V31.2725Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4537 31.7238H41.4177V32.7797H42.4537V31.7238Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6736 32.1773H43.6376V33.2332H44.6736V32.1773Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8916 32.6307H45.8556V33.6866H46.8916V32.6307Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6258 31.4296H29.5898V32.4855H30.6258V31.4296Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6959 31.7238H31.6619V32.7797H32.6959V31.7238Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9137 32.1773H33.8777V33.2332H34.9137V32.1773Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9838 32.4796H35.9478V33.5354H36.9838V32.4796Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2018 32.9308H38.1658V33.9867H39.2018V32.9308Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2718 33.3843H40.2358V34.4402H41.2718V33.3843Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4897 33.6865H42.4537V34.7424H43.4897V33.6865Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5596 34.1379H44.5236V35.1918H45.5596V34.1379Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6296 34.4402H46.5956V35.4961H47.6296V34.4402Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3996 33.8376H31.3677V34.8935H32.4036L32.3996 33.8376Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3219 33.9868H33.2859V35.0427H34.3219V33.9868Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2438 34.4402H35.2078V35.4961H36.2438V34.4402Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3138 34.7424H37.2778V35.7983H38.3138V34.7424Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2356 35.0366H39.2017V36.0925H40.2356V35.0366Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3077 35.345H41.2637V36.4009H42.2996L42.3077 35.345Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3657 35.6472H43.3297V36.7031H44.3657V35.6472Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2996 35.9474H45.2635V37.0033H46.2975L46.2996 35.9474Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2216 36.2517H47.1876V37.3136H48.2216V36.2517Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7298 35.9474H32.6938V37.0033H33.7298V35.9474Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6517 36.2517H34.6157V37.3136H35.6517V36.2517Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4198 36.4009H36.3838V37.4568H37.4198V36.4009Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3497 36.7031H38.3157V37.759H39.3517L39.3497 36.7031Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2718 37.0033H40.2358V38.0592H41.2718V37.0033Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1937 37.3057H42.1597V38.3616H43.1937V37.3057Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1157 37.4568H44.0817V38.5127H45.1157V37.4568Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8916 37.759H45.8556V38.8149H46.8916V37.759Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6655 37.9102H47.6295V38.9661H48.6655V37.9102Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9137 38.0592H33.8777V39.1151H34.9137V38.0592Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6876 38.2164H35.6516V39.2723H36.6876V38.2164Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4617 38.5127H37.4277V39.5686H38.4617V38.5127Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2356 38.6638H39.2017V39.7197H40.2356V38.6638Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0098 38.8149H40.9758V39.8708H42.0098V38.8149Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9316 39.1172H42.8976V40.1731H43.9316V39.1172Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7077 39.2764H44.6737V40.3323H45.7077V39.2764Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4817 39.4175H46.4457V40.4734H47.4817V39.4175Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1096 39.5685H48.0736V40.6244H49.1096V39.5685Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9459 40.0219H34.9119V41.0778H35.9459V40.0219Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5738 40.173H36.5378V41.2289H37.5738V40.173Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2018 40.3242H38.1658V41.3801H39.2018V40.3242Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9777 40.4732H39.9417V41.5291H40.9777V40.4732Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7518 40.6245H41.7158V41.6803H42.7518V40.6245Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3657 40.7756H43.3297V41.8315H44.3657V40.7756Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1516 40.9267H45.1156V41.9806H46.1516V40.9267Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7797 41.0778H46.7377V42.1337H47.7737L47.7797 41.0778Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5537 41.2289H48.5177V42.2848H49.5537V41.2289Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6876 41.9826H35.6516V43.0405H36.6876V41.9826Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3138 41.9826H37.2778V43.0405H38.3138V41.9826Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9456 42.1317H38.9097V43.1875H39.9456V42.1317Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5677 42.2849H40.5317V43.3407H41.5677V42.2849Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1937 42.2849H42.1597V43.3407H43.1937V42.2849Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8217 42.436H43.7897V43.4919H44.8257L44.8217 42.436Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5957 42.5871H45.5597V43.643H46.5957V42.5871Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2216 42.7363H47.1876V43.7922H48.2216V42.7363Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7017 42.7363H48.6656V43.7922H49.7017V42.7363Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2797 43.643H36.2437V44.6989H37.2797V43.643Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7577 43.7941H37.7217V44.85H38.7577V43.7941Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3858 43.7941H39.3499V44.85H40.3858V43.7941Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0098 43.9433H40.9758V44.9992H42.0098V43.9433Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6377 43.9433H42.6017V44.9992H43.6377V43.9433Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2656 44.0943H44.2296V45.1603H45.2656V44.0943Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8916 44.0943H45.8556V45.1603H46.8916V44.0943Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3657 44.2455H47.3297V45.3014H48.3657V44.2455Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9955 44.2455H48.9615V45.3014H49.9955V44.2455Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7217 45.3013H36.6877V46.3572H37.7217V45.3013Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2018 45.4526H38.1658V46.5085H39.2018V45.4526Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8278 45.4526H39.7898V46.5085H40.8238L40.8278 45.4526Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3077 45.4526H41.2637V46.5085H42.2996L42.3077 45.4526Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9316 45.6037H42.8976V46.6596H43.9316V45.6037Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5596 45.6037H44.5236V46.6596H45.5596V45.6037Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0375 45.7527H46.0035V46.8086H47.0375V45.7527Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5176 45.7527H47.4816V46.8086H48.5176V45.7527Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1455 45.7527H49.1095V46.8086H50.1455V45.7527Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0196 46.9597H36.9836V48.0156H38.0196V46.9597Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4977 46.9597H38.4617V48.0156H39.4977V46.9597Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1236 47.1108H40.0876V48.1667H41.1236V47.1108Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6019 47.1108H41.5679V48.1667H42.6019V47.1108Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2297 47.1108H43.1937V48.1667H44.2297V47.1108Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7077 47.1108H44.6737V48.1667H45.7077V47.1108Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1875 47.264H46.1515V48.3199H47.1875V47.264Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6655 47.264H47.6295V48.3199H48.6655V47.264Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2916 47.264H49.2616V48.3199H50.2976L50.2916 47.264Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3138 48.469H37.2778V49.5249H38.3138V48.469Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7938 48.469H38.7578V49.5249H39.7938V48.469Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2718 48.6101H40.2358V49.666H41.2718V48.6101Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7518 48.6101H41.7158V49.666H42.7518V48.6101Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3657 48.6101H43.3297V49.666H44.3657V48.6101Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8556 48.6101H44.8217V49.666H45.8556V48.6101Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3337 48.6101H46.2977V49.666H47.3337V48.6101Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8117 48.7714H47.7877V49.8273H48.8217L48.8117 48.7714Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2916 48.7714H49.2616V49.8273H50.2976L50.2916 48.7714Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4617 49.9784H37.4277V51.0343H38.4617V49.9784Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9456 49.9784H38.9097V51.0343H39.9456V49.9784Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4197 50.1295H40.3857V51.1854H41.4197V50.1295Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8937 50.1295H41.8577V51.1854H42.8937V50.1295Z",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3657 50.1295H43.3297V51.1854H44.3657V50.1295Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8556 50.1295H44.8217V51.1854H45.8556V50.1295Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3337 50.1295H46.2977V51.1854H47.3337V50.1295Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8117 50.1295H47.7877V51.1854H48.8217L48.8117 50.1295Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2916 50.1295H49.2616V51.1854H50.2976L50.2916 50.1295Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6097 51.4877H37.5737V52.5436H38.6097V51.4877Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0878 51.4877H39.0518V52.5436H40.0878V51.4877Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5677 51.4877H40.5317V52.5436H41.5677V51.4877Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0458 51.4877H42.0098V52.5436H43.0458V51.4877Z",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5236 51.4877H43.4896V52.5436H44.5236V51.4877Z",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0037 51.4877H44.9677V52.5436H46.0037V51.4877Z",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4817 51.4877H46.4457V52.5436H47.4817V51.4877Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9617 51.6368H47.9257V52.6927H48.9617V51.6368Z",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4397 51.6368H49.4037V52.6927H50.4397V51.6368Z",
    fill: "white"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6097 52.995H37.5737V54.0509H38.6097V52.995Z",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0878 52.995H39.0518V54.0509H40.0878V52.995Z",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5677 52.995H40.5317V54.0509H41.5677V52.995Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0458 52.995H42.0098V54.0509H43.0458V52.995Z",
    fill: "white"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5236 52.995H43.4896V54.0509H44.5236V52.995Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0037 52.995H44.9677V54.0509H46.0037V52.995Z",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4817 52.995H46.4457V54.0509H47.4817V52.995Z",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9617 52.995H47.9257V54.0509H48.9617V52.995Z",
    fill: "white"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4397 52.995H49.4037V54.0509H50.4397V52.995Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7577 54.3531H37.7217V55.409H38.7577V54.3531Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2356 54.3531H39.2017V55.409H40.2356V54.3531Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5677 54.3531H40.5317V55.409H41.5677V54.3531Z",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0458 54.3531H42.0098V55.409H43.0458V54.3531Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5236 54.3531H43.4896V55.409H44.5236V54.3531Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0037 54.3531H44.9677V55.409H46.0037V54.3531Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4817 54.3531H46.4457V55.409H47.4817V54.3531Z",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9617 54.3531H47.9257V55.409H48.9617V54.3531Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4397 54.3531H49.4037V55.409H50.4397V54.3531Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7577 55.8603H37.7217V56.9162H38.7577V55.8603Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2356 55.8603H39.2017V56.9162H40.2356V55.8603Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7157 55.8603H40.6797V56.9162H41.7157V55.8603Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0458 55.8603H42.0098V56.9162H43.0458V55.8603Z",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5236 55.8603H43.4896V56.9162H44.5236V55.8603Z",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0037 55.8603H44.9677V56.9162H46.0037V55.8603Z",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4817 55.8603H46.4457V56.9162H47.4817V55.8603Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9617 55.8603H47.9257V56.9162H48.9617V55.8603Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4397 55.8603H49.4037V56.9162H50.4397V55.8603Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7577 57.2205H37.7217V58.2764H38.7577V57.2205Z",
    fill: "white"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2356 57.2205H39.2017V58.2764H40.2356V57.2205Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7157 57.2205H40.6797V58.2764H41.7157V57.2205Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0458 57.2205H42.0098V58.2764H43.0458V57.2205Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5236 57.2205H43.4896V58.2764H44.5236V57.2205Z",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0037 57.2205H44.9677V58.2764H46.0037V57.2205Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4817 57.2205H46.4457V58.2764H47.4817V57.2205Z",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9617 57.2205H47.9257V58.2764H48.9617V57.2205Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4397 57.2205H49.4037V58.2764H50.4397V57.2205Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7879 59.4815L22.1879 59.7838H22.7879V59.4815Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2659 59.7857V59.0301L23.0839 59.4835V59.7857H24.2659Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5979 59.7837C25.5828 59.4276 25.5325 59.0739 25.4479 58.7278C25.1539 58.7278 24.8479 58.879 24.5619 58.879V59.6346H25.5979V59.7837Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7577 58.5787H37.7217V59.6346H38.7577V58.5787Z",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2356 58.5787H39.2017V59.6346H40.2356V58.5787Z",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7157 58.5787H40.6797V59.6346H41.7157V58.5787Z",
    fill: "white"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0458 58.5787H42.0098V59.6346H43.0458V58.5787Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5236 58.5787H43.4896V59.6346H44.5236V58.5787Z",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0037 58.5787H44.9677V59.6346H46.0037V58.5787Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4817 58.5787H46.4457V59.6346H47.4817V58.5787Z",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9617 58.5787H47.9257V59.6346H48.9617V58.5787Z",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4397 58.5787H49.4037V59.6346H50.4397V58.5787Z",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3498 60.9886L18.0538 61.1378H18.3498V60.9886Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8298 61.1417V60.5372L18.7938 60.8395V61.1417H19.8298Z",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3098 61.1418V60.0859L20.2738 60.3882V61.1438L21.3098 61.1418Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7878 60.0859H21.7518V61.1418H22.7878V60.0859Z",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1179 60.0859H23.0839V61.1418H24.1179V60.0859Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5979 60.0859H24.5619V61.1418H25.5979V60.0859Z",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1899 61.1417C26.1899 60.9906 26.1899 60.9906 26.0399 60.8395L26.1899 61.1417Z",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2796 60.5372C37.3019 60.7503 37.2488 60.9644 37.1296 61.1417H37.2796V60.5372Z",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7577 60.0859H37.7217V61.1418H38.7577V60.0859Z",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2356 60.0859H39.2017V61.1418H40.2356V60.0859Z",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7157 60.0859H40.6797V61.1418H41.7157V60.0859Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0458 60.0859H42.0098V61.1418H43.0458V60.0859Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5236 60.0859H43.4896V61.1418H44.5236V60.0859Z",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0037 60.0859H44.9677V61.1418H46.0037V60.0859Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4817 60.0859H46.4457V61.1418H47.4817V60.0859Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9617 60.0859H47.9257V61.1418H48.9617V60.0859Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4397 60.0859H49.4037V61.1418H50.4397V60.0859Z",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5419 62.5V62.0466L14.3579 62.3489V62.5H15.5419Z",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8718 62.5V61.4441L15.8378 61.8975V62.502L16.8718 62.5Z",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3518 61.4441H17.3158V62.5H18.3518V61.4441Z",
    fill: "white"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8298 61.4441H18.7938V62.5H19.8298V61.4441Z",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3098 61.4441H20.2738V62.5H21.3098V61.4441Z",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7878 61.4441H21.7518V62.5H22.7878V61.4441Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1179 61.4441H23.0839V62.5H24.1179V61.4441Z",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5979 61.4441H24.5619V62.5H25.5979V61.4441Z",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0399 62.5H26.7819C26.6319 62.1977 26.4859 61.7443 26.3379 61.4441H26.0419L26.0399 62.5Z",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2777 61.4441C37.1297 61.7464 36.9837 62.1997 36.8357 62.5H37.2777V61.4441Z",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7577 61.4441H37.7217V62.5H38.7577V61.4441Z",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2356 61.4441H39.2017V62.5H40.2356V61.4441Z",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7157 61.4441H40.6797V62.5H41.7157V61.4441Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0458 61.4441H42.0098V62.5H43.0458V61.4441Z",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5236 61.4441H43.4896V62.5H44.5236V61.4441Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0037 61.4441H44.9677V62.5H46.0037V61.4441Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4817 61.4441H46.4457V62.5H47.4817V61.4441Z",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9617 61.4441H47.9257V62.5H48.9617V61.4441Z",
    fill: "white"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4037 61.4441V62.5H50.4397C50.4397 62.1977 50.5877 61.7443 50.5877 61.4441H49.4037Z",
    fill: "white"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M14.058 62.8002H13.32C13.3002 62.7997 13.2804 62.8032 13.2619 62.8106C13.2435 62.818 13.2267 62.8291 13.2127 62.8433C13.1987 62.8574 13.1876 62.8743 13.1803 62.8929C13.1729 62.9115 13.1694 62.9314 13.17 62.9514C13.17 63.2536 13.32 63.5559 13.32 63.8561H14.206L14.058 62.8002Z",
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3939 62.8002H14.3579V63.8561H15.3939V62.8002Z",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8718 62.8002H15.8378V63.8561H16.8718V62.8002Z",
    fill: "white"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3518 62.8002H17.3158V63.8561H18.3518V62.8002Z",
    fill: "white"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8298 62.8002H18.7938V63.8561H19.8298V62.8002Z",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3098 62.8002H20.2738V63.8561H21.3098V62.8002Z",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7878 62.8002H21.7518V63.8561H22.7878V62.8002Z",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1179 62.8002H23.0839V63.8561H24.1179V62.8002Z",
    fill: "white"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5979 62.8002H24.5619V63.8561H25.5979V62.8002Z",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0399 64.0072H27.0759V63.1024C27.0759 62.9513 26.9279 62.9513 26.9279 62.8002H26.0399V64.0072Z",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8139 64.0072L27.5199 63.705V64.0072H27.8139Z",
    fill: "white"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2798 64.0072V62.9513H36.6798C36.5364 63.333 36.3339 63.6894 36.0798 64.0072H37.2798Z",
    fill: "white"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7577 62.8002H37.7217V63.8561H38.7577V62.8002Z",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2356 62.8002H39.2017V63.8561H40.2356V62.8002Z",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7157 62.8002H40.6797V63.8561H41.7157V62.8002Z",
    fill: "white"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0458 62.8002H42.0098V63.8561H43.0458V62.8002Z",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5236 62.8002H43.4896V63.8561H44.5236V62.8002Z",
    fill: "white"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0037 62.8002H44.9677V63.8561H46.0037V62.8002Z",
    fill: "white"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4817 62.8002H46.4457V63.8561H47.4817V62.8002Z",
    fill: "white"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9617 62.8002H47.9257V63.8561H48.9617V62.8002Z",
    fill: "white"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4037 64.0072H50.1417C50.2642 63.6696 50.3153 63.3099 50.2916 62.9513H49.4037V64.0072Z",
    fill: "white"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0661 64.3075H13.3281C13.4761 64.6098 13.4761 65.0631 13.6221 65.3634H14.2221L14.0661 64.3075Z",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3939 64.3075H14.3579V65.3634H15.3939V64.3075Z",
    fill: "white"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8718 64.3075H15.8378V65.3634H16.8718V64.3075Z",
    fill: "white"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3518 64.3075H17.3158V65.3634H18.3518V64.3075Z",
    fill: "white"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8298 64.3075H18.7938V65.3634H19.8298V64.3075Z",
    fill: "white"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3098 64.3075H20.2738V65.3634H21.3098V64.3075Z",
    fill: "white"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7878 64.3075H21.7518V65.3634H22.7878V64.3075Z",
    fill: "white"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1179 64.3075H23.0839V65.3634H24.1179V64.3075Z",
    fill: "white"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5979 64.3075H24.5619V65.3634H25.5979V64.3075Z",
    fill: "white"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0759 64.3075H26.0399V65.3634H27.0759V64.3075Z",
    fill: "white"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5198 65.3654H28.5538V64.6098L28.1118 64.1564H27.5118V65.3654H27.5198Z",
    fill: "white"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8858 65.3654L28.9978 64.912V65.3654H29.8858Z",
    fill: "white"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7999 65.3674V64.3075C35.4927 64.6077 35.1445 64.8622 34.7659 65.0631V65.3654L35.7999 65.3674Z",
    fill: "white"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2797 64.3075H36.2437V65.3634H37.2797V64.3075Z",
    fill: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7577 64.3075H37.7217V65.3634H38.7577V64.3075Z",
    fill: "white"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2356 64.3075H39.2017V65.3634H40.2356V64.3075Z",
    fill: "white"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7157 64.3075H40.6797V65.3634H41.7157V64.3075Z",
    fill: "white"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0458 64.3075H42.0098V65.3634H43.0458V64.3075Z",
    fill: "white"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5236 64.3075H43.4896V65.3634H44.5236V64.3075Z",
    fill: "white"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0037 64.3075H44.9677V65.3634H46.0037V64.3075Z",
    fill: "white"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4817 64.3075H46.4457V65.3634H47.4817V64.3075Z",
    fill: "white"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9617 64.3075H47.9257V65.3634H48.9617V64.3075Z",
    fill: "white"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4037 65.3674H49.8477C49.9957 65.0652 49.9957 64.6118 50.1417 64.3115H49.4037V65.3674Z",
    fill: "white"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0619 65.6656H13.6179C13.7659 65.9679 13.7659 66.4213 13.9139 66.7215H14.0619V65.6656Z",
    fill: "white"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3939 65.6656H14.3579V66.7215H15.3939V65.6656Z",
    fill: "white"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8718 65.6656H15.8378V66.7215H16.8718V65.6656Z",
    fill: "white"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3518 65.6656H17.3158V66.7215H18.3518V65.6656Z",
    fill: "white"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8298 65.6656H18.7938V66.7215H19.8298V65.6656Z",
    fill: "white"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3098 65.6656H20.2738V66.7215H21.3098V65.6656Z",
    fill: "white"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7878 65.6656H21.7518V66.7215H22.7878V65.6656Z",
    fill: "white"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1179 65.6656H23.0839V66.7215H24.1179V65.6656Z",
    fill: "white"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5979 65.6656H24.5619V66.7215H25.5979V65.6656Z",
    fill: "white"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0759 65.6656H26.0399V66.7215H27.0759V65.6656Z",
    fill: "white"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5539 65.6656H27.5199V66.7215H28.5539V65.6656Z",
    fill: "white"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0338 65.6656H28.9978V66.7215H30.0338V65.6656Z",
    fill: "white"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4778 66.7236H31.5118V65.6677H30.4778V66.7236Z",
    fill: "white"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9896 66.7236V65.6677H31.8057V66.7236H32.9896Z",
    fill: "white"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3219 65.6656H33.2859V66.7215H34.3219V65.6656Z",
    fill: "white"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7999 65.6656H34.7659V66.7215H35.7999V65.6656Z",
    fill: "white"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2797 65.6656H36.2437V66.7215H37.2797V65.6656Z",
    fill: "white"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7577 65.6656H37.7217V66.7215H38.7577V65.6656Z",
    fill: "white"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2356 65.6656H39.2017V66.7215H40.2356V65.6656Z",
    fill: "white"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7157 65.6656H40.6797V66.7215H41.7157V65.6656Z",
    fill: "white"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0458 65.6656H42.0098V66.7215H43.0458V65.6656Z",
    fill: "white"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5236 65.6656H43.4896V66.7215H44.5236V65.6656Z",
    fill: "white"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0037 65.6656H44.9677V66.7215H46.0037V65.6656Z",
    fill: "white"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4817 65.6656H46.4457V66.7215H47.4817V65.6656Z",
    fill: "white"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9617 65.6656H47.9257V66.7215H48.9617V65.6656Z",
    fill: "white"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4037 66.7236C49.5696 66.3944 49.6701 66.0357 49.6997 65.6677H49.4037V66.7236Z",
    fill: "white"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3939 67.0238H14.3579V68.0797H15.3939V67.0238Z",
    fill: "white"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8718 67.0238H15.8378V68.0797H16.8718V67.0238Z",
    fill: "white"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3518 67.0238H17.3158V68.0797H18.3518V67.0238Z",
    fill: "white"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8298 67.0238H18.7938V68.0797H19.8298V67.0238Z",
    fill: "white"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3098 67.0238H20.2738V68.0797H21.3098V67.0238Z",
    fill: "white"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7878 67.0238H21.7518V68.0797H22.7878V67.0238Z",
    fill: "white"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1179 67.0238H23.0839V68.0797H24.1179V67.0238Z",
    fill: "white"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5979 67.0238H24.5619V68.0797H25.5979V67.0238Z",
    fill: "white"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0759 67.0238H26.0399V68.0797H27.0759V67.0238Z",
    fill: "white"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5539 67.0238H27.5199V68.0797H28.5539V67.0238Z",
    fill: "white"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0338 67.0238H28.9978V68.0797H30.0338V67.0238Z",
    fill: "white"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5118 67.0238H30.4778V68.0797H31.5118V67.0238Z",
    fill: "white"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8418 67.0238H31.8079V68.0797H32.8418V67.0238Z",
    fill: "white"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3219 67.0238H33.2859V68.0797H34.3219V67.0238Z",
    fill: "white"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7999 67.0238H34.7659V68.0797H35.7999V67.0238Z",
    fill: "white"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2797 67.0238H36.2437V68.0797H37.2797V67.0238Z",
    fill: "white"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7577 67.0238H37.7217V68.0797H38.7577V67.0238Z",
    fill: "white"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2356 67.0238H39.2017V68.0797H40.2356V67.0238Z",
    fill: "white"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7157 67.0238H40.6797V68.0797H41.7157V67.0238Z",
    fill: "white"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0458 67.0238H42.0098V68.0797H43.0458V67.0238Z",
    fill: "white"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5236 67.0238H43.4896V68.0797H44.5236V67.0238Z",
    fill: "white"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0037 67.0238H44.9677V68.0797H46.0037V67.0238Z",
    fill: "white"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4817 67.0238H46.4457V68.0797H47.4817V67.0238Z",
    fill: "white"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9257 67.0239V68.0798H48.8117C48.8117 67.9286 48.9617 67.7775 48.9617 67.6264V67.0219L47.9257 67.0239Z",
    fill: "white"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M15.542 68.5351H14.5081C14.6561 68.8374 14.802 69.2907 14.95 69.591H15.55L15.542 68.5351Z",
    fill: "white"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8718 68.5351H15.8378V69.591H16.8718V68.5351Z",
    fill: "white"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3518 68.5351H17.3158V69.591H18.3518V68.5351Z",
    fill: "white"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8298 68.5351H18.7938V69.591H19.8298V68.5351Z",
    fill: "white"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3098 68.5351H20.2738V69.591H21.3098V68.5351Z",
    fill: "white"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7878 68.5351H21.7518V69.591H22.7878V68.5351Z",
    fill: "white"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1179 68.5351H23.0839V69.591H24.1179V68.5351Z",
    fill: "white"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5979 68.5351H24.5619V69.591H25.5979V68.5351Z",
    fill: "white"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0759 68.5351H26.0399V69.591H27.0759V68.5351Z",
    fill: "white"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5539 68.5351H27.5199V69.591H28.5539V68.5351Z",
    fill: "white"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0338 68.5351H28.9978V69.591H30.0338V68.5351Z",
    fill: "white"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5118 68.5351H30.4778V69.591H31.5118V68.5351Z",
    fill: "white"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8418 68.5351H31.8079V69.591H32.8418V68.5351Z",
    fill: "white"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3219 68.5351H33.2859V69.591H34.3219V68.5351Z",
    fill: "white"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7999 68.5351H34.7659V69.591H35.7999V68.5351Z",
    fill: "white"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2797 68.5351H36.2437V69.591H37.2797V68.5351Z",
    fill: "white"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7577 68.5351H37.7217V69.591H38.7577V68.5351Z",
    fill: "white"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2356 68.5351H39.2017V69.591H40.2356V68.5351Z",
    fill: "white"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7157 68.5351H40.6797V69.591H41.7157V68.5351Z",
    fill: "white"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0458 68.5351H42.0098V69.591H43.0458V68.5351Z",
    fill: "white"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5236 68.5351H43.4896V69.591H44.5236V68.5351Z",
    fill: "white"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0037 68.5351H44.9677V69.591H46.0037V68.5351Z",
    fill: "white"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4817 68.5351H46.4457V69.591H47.4817V68.5351Z",
    fill: "white"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9257 69.591C48.2197 69.2757 48.4682 68.9203 48.6637 68.5351H47.9257V69.591Z",
    fill: "white"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0978 69.8912C15.2458 70.1934 15.3918 70.3446 15.5398 70.6468V69.8912H15.0978Z",
    fill: "white"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8718 69.8912H15.8378V70.9471H16.8718V69.8912Z",
    fill: "white"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3518 69.8912H17.3158V70.9471H18.3518V69.8912Z",
    fill: "white"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8298 69.8912H18.7938V70.9471H19.8298V69.8912Z",
    fill: "white"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3098 69.8912H20.2738V70.9471H21.3098V69.8912Z",
    fill: "white"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7878 69.8912H21.7518V70.9471H22.7878V69.8912Z",
    fill: "white"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1179 69.8912H23.0839V70.9471H24.1179V69.8912Z",
    fill: "white"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5979 69.8912H24.5619V70.9471H25.5979V69.8912Z",
    fill: "white"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0759 69.8912H26.0399V70.9471H27.0759V69.8912Z",
    fill: "white"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5539 69.8912H27.5199V70.9471H28.5539V69.8912Z",
    fill: "white"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0338 69.8912H28.9978V70.9471H30.0338V69.8912Z",
    fill: "white"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5118 69.8912H30.4778V70.9471H31.5118V69.8912Z",
    fill: "white"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8418 69.8912H31.8079V70.9471H32.8418V69.8912Z",
    fill: "white"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3219 69.8912H33.2859V70.9471H34.3219V69.8912Z",
    fill: "white"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7999 69.8912H34.7659V70.9471H35.7999V69.8912Z",
    fill: "white"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2797 69.8912H36.2437V70.9471H37.2797V69.8912Z",
    fill: "white"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7577 69.8912H37.7217V70.9471H38.7577V69.8912Z",
    fill: "white"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2356 69.8912H39.2017V70.9471H40.2356V69.8912Z",
    fill: "white"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7157 69.8912H40.6797V70.9471H41.7157V69.8912Z",
    fill: "white"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0458 69.8912H42.0098V70.9471H43.0458V69.8912Z",
    fill: "white"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5236 69.8912H43.4896V70.9471H44.5236V69.8912Z",
    fill: "white"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0037 69.8912H44.9677V70.9471H46.0037V69.8912Z",
    fill: "white"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4457 69.8912V70.9471H47.3337C47.4817 70.796 47.4817 70.6449 47.6277 70.6449V69.8892L46.4457 69.8912Z",
    fill: "white"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8718 71.2495H15.8378C16.1318 71.5517 16.2797 72.0051 16.5757 72.3053H16.8697L16.8718 71.2495Z",
    fill: "white"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3518 71.2495H17.3158V72.3114H18.3518V71.2495Z",
    fill: "white"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8298 71.2495H18.7938V72.3114H19.8298V71.2495Z",
    fill: "white"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3098 71.2495H20.2738V72.3114H21.3098V71.2495Z",
    fill: "white"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7878 71.2495H21.7518V72.3114H22.7878V71.2495Z",
    fill: "white"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1179 71.2495H23.0839V72.3114H24.1179V71.2495Z",
    fill: "white"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5979 71.2495H24.5619V72.3114H25.5979V71.2495Z",
    fill: "white"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0759 71.2495H26.0399V72.3114H27.0759V71.2495Z",
    fill: "white"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5539 71.2495H27.5199V72.3114H28.5539V71.2495Z",
    fill: "white"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0338 71.2495H28.9978V72.3114H30.0338V71.2495Z",
    fill: "white"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5118 71.2495H30.4778V72.3114H31.5118V71.2495Z",
    fill: "white"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8418 71.2495H31.8079V72.3114H32.8418V71.2495Z",
    fill: "white"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3219 71.2495H33.2859V72.3114H34.3219V71.2495Z",
    fill: "white"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7999 71.2495H34.7659V72.3114H35.7999V71.2495Z",
    fill: "white"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2797 71.2495H36.2437V72.3114H37.2797V71.2495Z",
    fill: "white"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7577 71.2495H37.7217V72.3114H38.7577V71.2495Z",
    fill: "white"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2356 71.2495H39.2017V72.3114H40.2356V71.2495Z",
    fill: "white"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7157 71.2495H40.6797V72.3114H41.7157V71.2495Z",
    fill: "white"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0458 71.2495H42.0098V72.3114H43.0458V71.2495Z",
    fill: "white"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5236 71.2495H43.4896V72.3114H44.5236V71.2495Z",
    fill: "white"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0037 71.2495H44.9677V72.3114H46.0037V71.2495Z",
    fill: "white"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4457 72.1541C46.6082 71.8743 46.8104 71.6197 47.0457 71.3985H46.4457V72.1541Z",
    fill: "white"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3518 72.6076H17.3158V73.2121L17.7598 73.6655H18.3598L18.3518 72.6076Z",
    fill: "white"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8298 72.6076H18.7938V73.6635H19.8298V72.6076Z",
    fill: "white"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3098 72.6076H20.2738V73.6635H21.3098V72.6076Z",
    fill: "white"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7878 72.6076H21.7518V73.6635H22.7878V72.6076Z",
    fill: "white"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1179 72.6076H23.0839V73.6635H24.1179V72.6076Z",
    fill: "white"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5979 72.6076H24.5619V73.6635H25.5979V72.6076Z",
    fill: "white"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0759 72.6076H26.0399V73.6635H27.0759V72.6076Z",
    fill: "white"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5539 72.6076H27.5199V73.6635H28.5539V72.6076Z",
    fill: "white"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0338 72.6076H28.9978V73.6635H30.0338V72.6076Z",
    fill: "white"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5118 72.6076H30.4778V73.6635H31.5118V72.6076Z",
    fill: "white"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8418 72.6076H31.8079V73.6635H32.8418V72.6076Z",
    fill: "white"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3219 72.6076H33.2859V73.6635H34.3219V72.6076Z",
    fill: "white"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7999 72.6076H34.7659V73.6635H35.7999V72.6076Z",
    fill: "white"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2797 72.6076H36.2437V73.6635H37.2797V72.6076Z",
    fill: "white"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7577 72.6076H37.7217V73.6635H38.7577V72.6076Z",
    fill: "white"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2356 72.6076H39.2017V73.6635H40.2356V72.6076Z",
    fill: "white"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7157 72.6076H40.6797V73.6635H41.7157V72.6076Z",
    fill: "white"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0458 72.6076H42.0098V73.6635H43.0458V72.6076Z",
    fill: "white"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5236 72.6076H43.4896V73.6635H44.5236V72.6076Z",
    fill: "white"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9677 73.6635L46.0037 72.6076H44.9677V73.6635Z",
    fill: "white"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0538 74.1149L18.3498 74.4171V74.1149H18.0538Z",
    fill: "white"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8298 74.1149H18.7938V74.8725L19.2378 75.3259H19.8378L19.8298 74.1149Z",
    fill: "white"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3098 74.1149H20.2738V75.1708H21.3098V74.1149Z",
    fill: "white"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7878 74.1149H21.7518V75.1708H22.7878V74.1149Z",
    fill: "white"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1179 74.1149H23.0839V75.1708H24.1179V74.1149Z",
    fill: "white"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5979 74.1149H24.5619V75.1708H25.5979V74.1149Z",
    fill: "white"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0759 74.1149H26.0399V75.1708H27.0759V74.1149Z",
    fill: "white"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5539 74.1149H27.5199V75.1708H28.5539V74.1149Z",
    fill: "white"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0338 74.1149H28.9978V75.1708H30.0338V74.1149Z",
    fill: "white"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5118 74.1149H30.4778V75.1708H31.5118V74.1149Z",
    fill: "white"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8418 74.1149H31.8079V75.1708H32.8418V74.1149Z",
    fill: "white"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3219 74.1149H33.2859V75.1708H34.3219V74.1149Z",
    fill: "white"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7999 74.1149H34.7659V75.1708H35.7999V74.1149Z",
    fill: "white"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2797 74.1149H36.2437V75.1708H37.2797V74.1149Z",
    fill: "white"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7577 74.1149H37.7217V75.1708H38.7577V74.1149Z",
    fill: "white"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2356 74.1149H39.2017V75.1708H40.2356V74.1149Z",
    fill: "white"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7157 74.1149H40.6797V75.1708H41.7157V74.1149Z",
    fill: "white"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0458 74.1149H42.0098V75.1708H43.0458V74.1149Z",
    fill: "white"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4896 75.0196C43.8652 74.7559 44.2118 74.4526 44.5236 74.1149H43.4896V75.0196Z",
    fill: "white"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M19.682 75.4729L19.828 75.62V75.4729H19.682Z",
    fill: "white"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2738 75.4729V75.9263C20.5842 76.1832 20.9342 76.3874 21.3098 76.5308V75.4749L20.2738 75.4729Z",
    fill: "white"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7878 75.4729H21.7518V76.5288H22.7878V75.4729Z",
    fill: "white"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1179 75.4729H23.0839V76.5288H24.1179V75.4729Z",
    fill: "white"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5979 75.4729H24.5619V76.5288H25.5979V75.4729Z",
    fill: "white"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0759 75.4729H26.0399V76.5288H27.0759V75.4729Z",
    fill: "white"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5539 75.4729H27.5199V76.5288H28.5539V75.4729Z",
    fill: "white"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0338 75.4729H28.9978V76.5288H30.0338V75.4729Z",
    fill: "white"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5118 75.4729H30.4778V76.5288H31.5118V75.4729Z",
    fill: "white"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8418 75.4729H31.8079V76.5288H32.8418V75.4729Z",
    fill: "white"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3219 75.4729H33.2859V76.5288H34.3219V75.4729Z",
    fill: "white"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7999 75.4729H34.7659V76.5288H35.7999V75.4729Z",
    fill: "white"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2797 75.4729H36.2437V76.5288H37.2797V75.4729Z",
    fill: "white"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7577 75.4729H37.7217V76.5288H38.7577V75.4729Z",
    fill: "white"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2356 75.4729H39.2017V76.5288H40.2356V75.4729Z",
    fill: "white"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6797 75.473V76.5289H41.1237C41.4177 76.3777 41.5677 76.2266 41.8617 76.2266V75.4709L40.6797 75.473Z",
    fill: "white"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0098 75.9263C42.3058 75.7752 42.4538 75.624 42.7478 75.4729H42.0098V75.9263Z",
    fill: "white"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8959 76.821L22.7819 77.2744V76.821H21.8959Z",
    fill: "white"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0839 76.821V77.4256C23.3779 77.5767 23.8239 77.7278 24.1179 77.879V76.9742L23.0839 76.821Z",
    fill: "white"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5979 76.821H24.5619V77.8769H25.5979V76.821Z",
    fill: "white"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0759 76.821H26.0399V77.8769H27.0759V76.821Z",
    fill: "white"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5539 76.821H27.5199V77.8769H28.5539V76.821Z",
    fill: "white"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0338 76.821H28.9978V77.8769H30.0338V76.821Z",
    fill: "white"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5118 76.821H30.4778V77.8769H31.5118V76.821Z",
    fill: "white"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8418 76.821H31.8079V77.8769H32.8418V76.821Z",
    fill: "white"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3219 76.821H33.2859V77.8769H34.3219V76.821Z",
    fill: "white"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7999 76.821H34.7659V77.8769H35.7999V76.821Z",
    fill: "white"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2797 76.821H36.2437V77.8769H37.2797V76.821Z",
    fill: "white"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7217 76.821V77.8769C38.0436 77.7077 38.3958 77.605 38.7577 77.5747V76.9702L37.7217 76.821Z",
    fill: "white"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2017 76.821V77.2744C39.4957 77.1233 39.9397 76.9722 40.2356 76.821H39.2017Z",
    fill: "white"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0399 78.3405C26.3359 78.4916 26.7819 78.4916 27.0759 78.6427V78.3405H26.0399Z",
    fill: "white"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5199 78.3405V78.6427C27.8139 78.6427 28.2579 78.7938 28.5539 78.7938V78.3405H27.5199Z",
    fill: "white"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9978 78.3405V78.7938H30.0338V78.3405H28.9978Z",
    fill: "white"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4778 78.3405V78.945H31.5118V78.3405H30.4778Z",
    fill: "white"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8079 78.3405V78.7938H32.8418V78.3405H31.8079Z",
    fill: "white"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2859 78.3405V78.7938C33.6379 78.8179 33.9911 78.7664 34.3219 78.6427V78.3405H33.2859Z",
    fill: "white"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7659 78.3405V78.6427C35.0599 78.6427 35.5039 78.4916 35.7999 78.4916H34.7659V78.3405Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuloLogoWhite);
export default __webpack_public_path__ + "static/media/julo-logo-white.ab190468e15a36abd1b34536397569bc.svg";
export { ForwardRef as ReactComponent };